import React, { Component } from 'react';
import {
  PageHeading,
  SectionHeading,
  SubsectionHeading
} from 'web-ui-components/lib/typography/headings';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import SwitchOption from './components/SwitchOption';
import SwitchService from './components/SwitchService';
import SwitchMailing from './components/SwitchMailing';
import { SwitchGuaranteeLogo } from 'web-ui-components/lib/atoms/logo';

class SwitchBusinessPage extends Component {
  render() {
    const { saveSwitchBusinessForm, getBusinessData } = this.props;
    return (
      <Form
        onSubmit={saveSwitchBusinessForm}
        initialValues={getBusinessData}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({
                switchBusinessPageTitle = '',
                switchBusinessContent,
                switchBusinessContent1,
                switchBusinessSwitchOptionValue1,
                switchBusinessContent3,
                switchBusinessContent4,
                switchBusinessContent5,
                switchBusinessContent6,
                switchBusinessContent7,
                switchBusinessContent8,
                switchBusinessContent9,
                switchBusinessContent10,
                switchBusinessContent11,
                switchBusinessContent12,
                switchBusinessContent13,
                switchBusinessContent14,
                switchBusinessContent15,
                switchBusinessContent16,
                switchBusinessContent17,
                switchBusinessContent18,
                switchBusinessContent19,
                switchChooseService,
                switchChooseServiceContent1,
                switchYourAccount,
                switchBusineContent20,
                switchBusinessSwitchMailingValue2
              }) => (
                <div>
                  <Inline.Justified
                    isNonWrapping
                    nodes={[
                      <PageHeading>{switchBusinessPageTitle}</PageHeading>,
                      <SwitchGuaranteeLogo />
                    ]}
                  />

                  <StandardBody>
                    <p>{switchBusinessContent}</p>
                    <p>{switchBusinessContent1}</p>
                  </StandardBody>
                  <SwitchOption values={values} />
                  {values.switchOption === switchBusinessSwitchOptionValue1 && (
                    <ConditionalPanel isVisible>
                      <StandardBody>
                        <SubsectionHeading>{switchChooseService}</SubsectionHeading>
                        <p>{switchChooseServiceContent1}</p>
                        <SubsectionHeading>{switchBusinessContent3}</SubsectionHeading>
                        <p>{switchBusinessContent4}</p>
                        <BulletList
                          items={[
                            switchBusinessContent5,
                            switchBusinessContent6,
                            switchBusinessContent7,
                            switchBusinessContent8
                          ]}
                        />

                        <p>{switchBusinessContent9}</p>
                        <SubsectionHeading>{switchBusinessContent10}</SubsectionHeading>
                        <p>{switchBusinessContent11}</p>
                        <BulletList
                          items={[
                            switchBusinessContent12,
                            switchBusinessContent13,
                            switchBusinessContent14,
                            switchBusinessContent15
                          ]}
                        />
                        <SubsectionHeading>{switchBusinessContent16}</SubsectionHeading>
                        <p>{switchBusinessContent17}</p>

                        <SectionHeading>{switchYourAccount}</SectionHeading>
                        <SwitchService values={values} />
                        <SubsectionHeading>{switchBusinessContent18}</SubsectionHeading>
                        <p>{switchBusinessContent19}</p>
                        <p>{switchBusineContent20}</p>
                      </StandardBody>
                      <SwitchMailing values={values} />
                    </ConditionalPanel>
                  )}
                  {values.switchMailing === switchBusinessSwitchMailingValue2 ? (
                    <div className="u-margin-top-2">
                      <Submit hideExit disabled />
                    </div>
                  ) : (
                    <Submit hideExit />
                  )}
                </div>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
SwitchBusinessPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveSwitchBusinessForm: PropTypes.func.isRequired
};

export default SwitchBusinessPage;
